import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
export default {
  state: {
    titleLayer: {},
    // 当前选中底图
    titleLayers: [],
    // 可供选择的底图列表
    cloudMapUpdateTime: []
  },
  getters: {
    mapSkin: function mapSkin(state) {
      return (state.titleLayers.find(function (v) {
        return v.checked;
      }) || {
        theme: 'dark'
      }).theme;
    }
  },
  mutations: {
    // 提交列表
    SET_TITLE_LAYERS: function SET_TITLE_LAYERS(state, data) {
      state.titleLayers = data;
    },
    // 提交当前选
    SET_TITLE_LAYER: function SET_TITLE_LAYER(state, data) {
      state.titleLayer = data;
    },
    // 提交云图地图最近一次获取时间
    SET_CLOUDMAP_UPDATE_TIME: function SET_CLOUDMAP_UPDATE_TIME(state, data) {
      state.cloudMapUpdateTime = data;
    }
  },
  actions: {
    setTitleLayer: function setTitleLayer(_ref, data) {
      var state = _ref.state,
          commit = _ref.commit;
      var titleLayers = state.titleLayers;
      titleLayers.forEach(function (el, i) {
        el.checked = el.id === data.id;
        titleLayers.splice(i, 1, el); // 强制更新
      });
      commit('SET_TITLE_LAYER', data);
      commit('SET_TITLE_LAYERS', titleLayers);
    },
    setTitleLayerById: function setTitleLayerById(_ref2, id) {
      var state = _ref2.state,
          commit = _ref2.commit;
      var titleLayers = state.titleLayers;
      var titleLayer = null;
      titleLayers.forEach(function (el, i) {
        var handle = el.id === id;
        el.checked = handle;
        if (handle) titleLayer = el;
        titleLayers.splice(i, 1, el); // 强制更新
      });
      if (!titleLayer) return;
      commit('SET_TITLE_LAYER', titleLayer);
      commit('SET_TITLE_LAYERS', titleLayers);
    }
  }
};